import { BaseApi } from '@/core/api/base.api'
import { Room } from "@/core/api/room.api";
import { roomNoticeService } from "@/core/service/room.notice.service";

class RoomNoticeApi extends BaseApi {
    #noticeData;
    
    constructor() {
        super();
        Room.Notice = this;

        Room.ready(async e => {
            this._eventListen(this.#Events);
            this.#noticeData = await this.getNotices();
            Room.emit({
                type: 'room_notice_init',
                data: this.#noticeData,
            })
        });
    }

    #Events = {
        room_notice_add(e) {
            Room.emit(e);
        },
        room_notice_delete(e) {
            Room.emit(e);
        },
        room_notice_fix(e) {
            Room.emit(e);
        },
    }

    async getNotices() {
        return (await roomNoticeService.getNotices()).data.data;
    }

    async getNotice() {
        return (await roomNoticeService.getNotice()).data.data;
    }
    
    async createNotice(params) {
        return (await roomNoticeService.createNotice(params)).data.data;
    }

    async deleteNotice(params) {
        return (await roomNoticeService.deleteNotice(params)).data.data;
    }

    async setNoticeFix(params) {
        return (await roomNoticeService.fixNotice(params)).data.data;
    }
}

export const RoomNotice = new RoomNoticeApi();
